import * as Yup from "yup";

import { validationObject as insuranceOwnerValidationObject } from "Components/Form/CommonFormElements/InsuranceOwnerFormElement/validation";
import { getInjuriesSchema } from "Components/Form/RecentDamages/validation";
import { MopedProductDetailsFormValues } from "../mopedInterface";

export const validationSchema =
  (): Yup.ObjectSchema<MopedProductDetailsFormValues> =>
    Yup.object()
      .shape({
        ...insuranceOwnerValidationObject(),
      })
      .concat(getInjuriesSchema());
